/**
 * Common functionalities for the Open Cluster Management plugin.
 *
 * @packageDocumentation
 */

export * from './types';
export * from './permissions';

export const ANNOTATION_CLUSTER_ID = 'janus-idp.io/ocm-cluster-id';
export const ANNOTATION_PROVIDER_ID = 'janus-idp.io/ocm-provider-id';
